import { deriveKeyMaterial, IDENTITY_SALT } from '@train-protocol/auth';
/**
 * Derive a deterministic login key from a Solana wallet.
 *
 * Signs a fixed UTF-8 message, then derives key material from the resulting
 * signature — analogous to the EVM approach using eth_signTypedData_v4.
 */
export const deriveKeyFromSolanaWallet = async (wallet) => {
    if (!wallet?.signMessage) {
        throw new Error('Solana wallet does not support message signing');
    }
    const message = new TextEncoder().encode('I am using TRAIN');
    const signature = await wallet.signMessage(message);
    const identitySalt = new TextEncoder().encode(IDENTITY_SALT);
    return new Uint8Array(deriveKeyMaterial(signature, identitySalt));
};
